import React, { useState, useEffect } from "react";
import { useInput } from "../../../../common/hooks";
import { Grid, Input, Button } from "semantic-ui-react";
import "./style.less";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  assignRmBuddyToBuddyBlock,
  setRmBuddiesServerSearchQuery
} from "../../../../redux/rm-buddies/actions";
import { viewAssignedBuddies } from "../../../../redux/geofence/actions";

function AssignRMBuddies({ viewAssignedBuddiesOf }) {
  const selectedPolygon = useSelector(({ geofence }) =>
    geofence.visibleGeofences.find(e => e._id === viewAssignedBuddiesOf)
  );

  const dispatch = useDispatch();
  const searchedRmBuddiesResults = useSelector(
    ({ rmBuddies }) => rmBuddies.searchedRmBuddiesResults
  );

  // Right now only one buddy can be assigned to Buddy block.
  // But server sends array of RM buddies so get 1st element
  const assignedBuddy = useSelector(
    ({ geofence }) =>
      geofence.assignedBuddies && geofence.assignedBuddies.length > 0
        ? geofence.assignedBuddies[0]
        : null,
    shallowEqual
  );
  const [selectedBuddy, setNewSelectedBuddy] = useState(assignedBuddy);
  const [searchInputVal, setSearchInputVal] = useInput("");
  useEffect(() => {
    dispatch(setRmBuddiesServerSearchQuery(searchInputVal));
  }, [dispatch, searchInputVal]);

  useEffect(() => {
    setNewSelectedBuddy(assignedBuddy);
  }, [assignedBuddy, setNewSelectedBuddy]);

  const assignBuddy = () => {
    if (!selectedBuddy && !assignedBuddy) {
      dispatch(viewAssignedBuddies(null));
      return;
    }
    if (
      assignedBuddy &&
      selectedBuddy &&
      selectedBuddy._id === assignedBuddy._id
    ) {
      dispatch(viewAssignedBuddies(null));
      return;
    }
    dispatch(
      assignRmBuddyToBuddyBlock({
        old_buddy_id: assignedBuddy ? assignedBuddy._id : null,
        new_buddy_id: selectedBuddy ? selectedBuddy._id : null,
        buddy_block_id: viewAssignedBuddiesOf
      })
    );
    dispatch(viewAssignedBuddies(null));
  };
  return selectedPolygon &&
    viewAssignedBuddiesOf &&
    selectedPolygon.properties.fenceCategory === "BUDDY_BLOCK" ? (
    <div className="AssignRMBuddies-main">
      <Grid>
        <Grid.Column className="AssignRMBuddies-leftBlock" width={7}>
          <h4>{selectedPolygon.properties.name}</h4>
          <h5>
            {Math.round(selectedPolygon.properties.area / 1000000) === 0
              ? Math.round(selectedPolygon.properties.area) + " sq. m"
              : Math.round(selectedPolygon.properties.area / 1000000) +
                " sq. Km"}
          </h5>
          <p>Buddy Block</p>
        </Grid.Column>
        <Grid.Column className="AssignRMBuddies-rightBlock" width={9}>
          <Input
            value={searchInputVal}
            onChange={setSearchInputVal}
            className="AssignRMBuddies-textBox"
            placeholder="Search by name or number"
            icon="search"
          />
          <div className="AssignRMBuddies-assigned">
            <h4>RM Buddies Assigned</h4>
            {selectedBuddy && (
              <div key={selectedBuddy._id} className="ui checkbox">
                <input type="checkbox" checked className="hidden" />
                <label>
                  <p className="AssignRMBuddies-checkboxName">
                    {selectedBuddy.name}
                  </p>
                  <p className="AssignRMBuddies-checkboxNumber">
                    {selectedBuddy.phone_num}
                  </p>
                </label>
              </div>
            )}
          </div>
          <br />
          <br />
          <div className="AssignRMBuddies-other">
            <h4>Search results</h4>
            <div className="AssignRMBuddies-scroll">
              {searchedRmBuddiesResults &&
                searchedRmBuddiesResults.map(e => (
                  <div
                    onClick={() => setNewSelectedBuddy(e)}
                    key={e._id}
                    className="ui checkbox"
                  >
                    <input type="checkbox" className="hidden" />
                    <label>
                      <p className="AssignRMBuddies-checkboxName">{e.name}</p>
                      <p className="AssignRMBuddies-checkboxNumber">
                        {e.phone_num}
                      </p>
                    </label>
                  </div>
                ))}
            </div>
            <Button onClick={assignBuddy} primary>
              Done
            </Button>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  ) : null;
}

AssignRMBuddies.defaultProps = {};

AssignRMBuddies.propTypes = {};

export default AssignRMBuddies;
